export enum EnvSessionStorageKeys {
    UserRefreshToken = 'user.refreshToken',
    UserSessionStorage = 'user.sessionStorage'
}